import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Notification } from '../../api/model/notification';
import { ResourcesService } from '../../api/resources/resources.service';
import { ToasterService } from '../../global/toaster.service';
import { NotificationsService } from '../../api/resources/notifications/notifications.service';
import * as moment from 'moment';
import { ProtocolService } from '../../global/protocol.service';
import { AgentService} from '../../api/resources/agent/agent.service';
import { StaticUtils } from '../../utils/static-utils';

@Component({
  selector: 'app-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.scss']
})
export class NotificationDetailsComponent implements OnInit {
  @Input() notification!: Notification;
  @Input() showFooter: boolean = true;
  @Input() modalType: 'default' | 'agreement' = 'default';
  @Input() showHeader: boolean = true;
  
  utils = StaticUtils;
  waitingResponse = false;
  moment = moment;
  private _message: any;

  constructor(
    public activeModal: NgbActiveModal,
    private _resourcesService: ResourcesService,
    private _toasterService: ToasterService,
    private _notifications: NotificationsService,
    private _protocolService: ProtocolService,
    private _agentService: AgentService) { }

  ngOnInit() {
    if (this.notification) {
      try {
        this._message = JSON.parse(this.notification.message);
      } catch (e) {
        this._message = false;
      }
    }
  }

  acceptProtocol(notification: Notification) {
    this.waitingResponse = true;
    this._resourcesService.get(
      notification.metadata,
      true,
      undefined
    ).subscribe(
      (result) => {
        this._toasterService.showInfo(result.data);
        this._agentService.updateSuppliers(true);
        this._protocolService.protocolAccepted.emit();
        this.activeModal.close();
      },
      undefined,
      () => this.waitingResponse = false
    );
  }

  formatDate(date: moment.Moment): string {
    let result = '';
    const today = moment();

    let diff = today.diff(date, 'years');
    if (diff === 0) {
      diff = today.diff(date, 'months');
      if (diff === 0) {
        diff = today.diff(date, 'weeks');
        if (diff === 0) {
          diff = today.diff(date, 'days');
          if (diff === 0) {
            diff = today.diff(date, 'hours');
            if (diff === 0) {
              diff = today.diff(date, 'minutes');
              if (diff === 0) {
                diff = today.diff(date, 'seconds');
                result = diff + ' seconds ago';
              } else if (diff === 1) {
                result = diff + ' minute ago';
              } else {
                result = diff + ' minutes ago';
              }
            } else if (diff === 1) {
              result = diff + ' hour ago';
            } else {
              result = diff + ' hours ago';
            }
          } else if (diff === 1) {
            result = diff + ' day ago';
          } else {
            result = diff + ' days ago';
          }
        } else if (diff === 1) {
          result = diff + ' week ago';
        } else {
          result = diff + ' weeks ago';
        }
      } else if (diff === 1) {
        result = diff + ' month ago';
      } else {
        result = diff + ' months ago';
      }
    } else if (diff === 1) {
      result = diff + ' year ago';
    } else {
      result = diff + ' years ago';
    }

    return result;
  }

  get protocolMessage(): any {
    return this._message;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/notification-details/notification-details.component.ts